import Plugin from "@ckeditor/ckeditor5-core/src/plugin";

export default class SourceEditing extends Plugin {
  init() {
    const editor = this.editor;
    const schema = editor.model.schema;

    schema.register("source", {
      allowWhere: "$block",
      allowContentOf: "$root",
      allowAttributes: [
        "src",
        "resource",
        "typeof",
        "data-node-name",
        "data-description",
        "data-credit-line",
        "title",
        "data-tenant-id",
        "rel",
      ],
    });

    editor.conversion.for("upcast").elementToElement({
      view: "source",
      model: (viewElement, { writer: modelWriter }) => {
        return modelWriter.createElement("source", viewElement.getAttributes());
      },
    });

    editor.conversion.for("downcast").elementToElement({
      model: "source",
      view: "source",
    });

    editor.conversion.for('downcast')
    .add(dispatcher => {
      dispatcher.on('attribute', (evt, data, conversionApi) => {
        if ((data.item.name === 'source') && (data.attributeKey === 'src' || data.attributeKey === 'resource')) {
          const viewWriter = conversionApi.writer;
          const viewElement = conversionApi.mapper.toViewElement(data.item);
          const originUrl = location.origin + '/alfresco/s/wk/content?tenantId=';
          const alf_ticket = localStorage.getItem('ticket-ECM')
          if (!data.attributeNewValue?.includes('alf_ticket=') && alf_ticket) {
              data.attributeNewValue = data.attributeNewValue + `&alf_ticket=${alf_ticket}`;
              viewWriter.setAttribute(data.attributeKey, data.attributeNewValue, viewElement);
          }
          if(!data.attributeNewValue?.includes(originUrl)){
            data.attributeNewValue = originUrl + data.attributeNewValue ;
            viewWriter.setAttribute(data.attributeKey, data.attributeNewValue, viewElement);
          }
        }
      });
    });
}
}